import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import CloseButton from "component/react-bootstrap/CloseButton";
import { useTranslation } from "next-i18next";
import HideIf from "../../util/HideIf";
import styles from "./modal.module.scss";

const ModalHeader = (props: any) => {
  const {
    closeButton, closeLabel, className = "", style = {}, onHide, children,
    backButton = false, backButtonClass = "", showWhite, closeButtonClass = "",
  } = props;

  const { t } = useTranslation();
  return (
    <div className={`modal-header ${styles.modal_header} ${className}`} style={style}>
      {children}

      <HideIf show={backButton}>
        <PAButton
          onClick={onHide}
          buttonType={BUTTON_TYPE.OUTLINE}
          className={`${styles.modal_back_button} ${backButtonClass}`}
          widthAuto
        >
          {t("Back")}
        </PAButton>
      </HideIf>

      <HideIf show={!backButton && closeButton}>
        <CloseButton
          label={closeLabel}
          onClick={onHide}
          showWhite={showWhite}
          className={closeButtonClass}
        />
      </HideIf>
    </div>
  );
};

export default ModalHeader;
